export default __webpack_public_path__ + "static/media/coca-cola.1c5fdd8d.png";